import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { ENgxPrintComponent } from "e-ngx-print";
import { ChartMenuService } from '../../service/chart-menu.service';
import { NoiseDropToolboxData } from '../../line/noise-dropbox-line/noise-dropbox-line-interface';


@Component({
  selector: 'bcac-noise-analysis-toolbox',
  templateUrl: './noise-analysis-toolbox.component.html',
  styleUrls: ['./noise-analysis-toolbox.component.scss']
})
export class NoiseAnalysisToolboxComponent implements OnInit {
  @ViewChild("print1", { static: false }) print1Component: ENgxPrintComponent;

  constructor(
    private chartMenuService: ChartMenuService
  ) { }


  @Input() chartInstance;

  @Input() fileName: string;
  //todo 声学分析带方块toolbox项目
  // @Input() bcacChartToolboxSwitchIntervalData: Array<any>; //interval数据
  // @Input() bcactoolboxDefaultIntervalData: number | string;//默认显示间隔
  // @Input() bcacChartToolboxSwitchValueData: Array<object>;//测量值数据
  // @Input() bcacChartDefaultValueData: Array<string>;//测量值默认显示项
  // @Output() bcactoolboxValueChange: EventEmitter<any> = new EventEmitter<any>()
  // @Output() bcactoolboxIntervalChange: EventEmitter<any> = new EventEmitter<any>()

  //todo 声学分析通用toolbox项目
  @Input() bcacNoiseDropToolboxData: NoiseDropToolboxData
  @Output() bcacToolboxSingleChoiceChange: EventEmitter<any> = new EventEmitter<any>()
  @Output() bcacToolboxMultipleChoiceChange: EventEmitter<any> = new EventEmitter<any>()
  @Output() bcacToolboxIntervalChange: EventEmitter<any> = new EventEmitter<any>()

  ngOnInit() {
  }

  // observer_singleChoiceData
  // observer_multipleChoiceData
  // observer_xIntervalData
  // observer_oldmultiple
  // observer_oldxInterval

  ngOnDestroy(): void {
  }
  _singleChoiceData
  _multipleChoiceData
  _xIntervalData
  radioValue_singleChoice
  radioValue_xInterval
  radioValue_oldxInterval
  ngOnChanges(changes: SimpleChanges) {
    if (changes.bcacNoiseDropToolboxData && this.bcacNoiseDropToolboxData) {
      if (this.bcacNoiseDropToolboxData.toolboxItem
        && this.bcacNoiseDropToolboxData.toolboxItem.includes('switchSingleChoice')
        && this.bcacNoiseDropToolboxData.singleChoiceData) {
        this._singleChoiceData = this.bcacNoiseDropToolboxData.singleChoiceData
        for (const item of this.bcacNoiseDropToolboxData.singleChoiceData) {
          if (item.ischecked) {
            this.radioValue_singleChoice = item.value
          }
        }
      }

      if ( this.bcacNoiseDropToolboxData.toolboxItem
        && (this.bcacNoiseDropToolboxData.toolboxItem.includes('switchMultipleChoice') || this.bcacNoiseDropToolboxData.toolboxItem.includes('switchValue'))
        && this.bcacNoiseDropToolboxData.multipleChoiceData
        && this.bcacNoiseDropToolboxData.multipleChoiceData.length) {
        this._multipleChoiceData = this.bcacNoiseDropToolboxData.multipleChoiceData
      }

      if (this.bcacNoiseDropToolboxData.toolboxItem
        && this.bcacNoiseDropToolboxData.toolboxItem.includes('switchInterval')
        && this.bcacNoiseDropToolboxData.xIntervalData) {
        this._xIntervalData = this.bcacNoiseDropToolboxData.xIntervalData
        for (const item of this.bcacNoiseDropToolboxData.xIntervalData) {
          if (item.ischecked) {
            this.radioValue_xInterval = item.value
          }
        }
      }
    }


  }

  closePanel(event) {
    let el = <HTMLElement>event.target;
    if (el) {
      el.setAttribute("style", "display:none");
    }
  }


  downloadImage(imageType: string, fileName: string) {
    this.chartMenuService.downloadEchartImage(this.chartInstance, fileName, imageType);
  }
  fullScreen(event) {
    const el = event.path[5];  //菜单下拉框
    this.chartMenuService.fullScreen(el);
  }
  customPrint() {
    this.chartMenuService.customPrint(this.chartInstance, this.print1Component);
  }
  /* //todo 显示值改变
  toolboxValueChange(item) {
    let checkedValue = []
    let checkbox = <HTMLCollection>document.getElementsByClassName('groupvaluebox')
    for (let i = 0, len = checkbox.length; i < len; i++) {
      if ((<HTMLInputElement>checkbox[i]).checked) {
        checkedValue.push((<HTMLInputElement>checkbox[i]).value)
      }
    }
    this.bcactoolboxValueChange.emit(checkedValue)
  } */

  /*  //todo 间隔改变
   toolboxIntervalChange(item) {
     this.bcactoolboxIntervalChange.emit(item.value)
   } */

  //todo 切换显示测量值
  /*   switchShowValue() {
      let checkbox = <HTMLCollection>document.getElementsByClassName('groupvaluebox')
      for (let i = 0, len = checkbox.length; i < len; i++) {
        if (this.bcacChartDefaultValueData.includes((<HTMLInputElement>checkbox[i]).value)) {
          (<HTMLInputElement>checkbox[i]).checked = true
        } else {
          (<HTMLInputElement>checkbox[i]).checked = false
        }
      }
    } */

  /* //todo 切换显示测量值
  showCheckedValue(value: string | string[] | number, node) {
    let res: boolean = false
    if (typeof (value) == 'string' || typeof (value) == 'number') { value = [value + ''] }
    let divbox = document.getElementById(node)
    let checkbox = <HTMLCollection>divbox.getElementsByClassName('groupvaluebox')
    for (let i = 0, len = checkbox.length; i < len; i++) {
      if (value.includes((<HTMLInputElement>checkbox[i]).value)) {
        (<HTMLInputElement>checkbox[i]).checked = true
        res = true
      } else {
        (<HTMLInputElement>checkbox[i]).checked = false
      }
    }
    return res
  } */



  /* //todo  x间隔改变
  xIntervalDataChange(value) {
    let checkedValue
    let divbox = document.getElementById('switchInterval')
    let checkbox = <HTMLCollection>divbox.getElementsByClassName('groupvaluebox')
    for (let i = 0, len = checkbox.length; i < len; i++) {
      if ((<HTMLInputElement>checkbox[i]).checked) {
        checkedValue = (<HTMLInputElement>checkbox[i]).value
      }
    }
    this.bcacToolboxIntervalChange.emit(checkedValue)
  } */

  //todo  x间隔改变
  xIntervalDataChange(value) {
    this.bcacToolboxIntervalChange.emit(value)
  }

  //todo 测量值改变
  singleChoiceChange(e) {
    let value
    this._singleChoiceData.map((item) => {
      if (item.value == e) {
        value = item
      }
    })
    this.bcacToolboxSingleChoiceChange.emit(value)
  }

  //todo 测量项改变
  multipleChoiceChange(e) {
    this.bcacToolboxMultipleChoiceChange.emit(e)
  }

  /*  //todo 测量项改变
   multipleChoiceChange(value) {
     let checkedValue = []
     const divbox = document.getElementById('multipleChoice')
     const checkbox = <HTMLCollection>divbox.getElementsByClassName('groupvaluebox')
     for (let i = 0, len = checkbox.length; i < len; i++) {
       if ((<HTMLInputElement>checkbox[i]).checked) {
         checkedValue.push((<HTMLInputElement>checkbox[i]).value)
       }
     }
     this.bcacToolboxMultipleChoiceChange.emit(checkedValue)
   } */





}
